export class BilledFilter {
    id: string = "";
    clientId: string = "";
    corporateName: string = "";
    pac: string = "";
    negId: string = "";
    negRef: string = "";
    popId: string = "";
}
